<template>
  <div>
    <v-card class="text-xs-center mt-4" hover>
      <div style="position: absolute; left: 13px; top: 13px">
        <v-badge overlap :value="driver.complianceCount > 0">
          <span slot="badge">{{ driver.complianceCount }}</span>
          <v-icon color="grey" class="ma-1" @click="goToCompliance()">{{ $store.state.global.pages.compliance.icon }}</v-icon>
        </v-badge>
      </div>
      <div style="position: absolute; right: 3px; top: 3px">
        <v-btn
          flat
          icon
          color="grey"
          @click="edit = true"
          v-if="userAuthClass || allowInductionEntry"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <v-menu v-model="chooseChildPage" bottom offset-y>
          <v-btn flat icon color="grey" slot="activator">
            <v-icon>subdirectory_arrow_right</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile ripple @click="goToCompliance()">
              <v-list-tile-action>
                <v-icon :color="$store.state.global.pages.compliance.color">{{ $store.state.global.pages.compliance.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Show Compliance</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>

      <div class>
        <v-avatar :color="color" size="66" class="overlap-avatar">
          <span class="white--text headline">{{letter.toUpperCase()}}</span>
        </v-avatar>
      </div>

      <v-card-text @click="chooseChildPage = true">
        <div class="pb-3">
          <h5 class="subheading font-weight-regular text-capitalize">{{driver.name}}</h5>
          <div class="grey--text text-capitalize">
            <span class="clickable">{{driver.contractor.name}}</span>
          </div>
        </div>
        <div class="pb-4">
          <h5
            class="subheading font-weight-regular grey--text text--darken-1"
          >{{driver.contactEmail}}</h5>
        </div>
        <!-- <master-file-compliance-resources model="driver" :resources="driver.complianceResources"></master-file-compliance-resources> -->
      </v-card-text>

      <v-card-actions>
        <v-btn
          flat
          icon
          color="grey"
          :href="'tel:'+driver.contactPhone"
          v-if="!!driver.contactPhone"
        >
          <v-icon>phone</v-icon>
        </v-btn>
        <v-btn
          flat
          icon
          color="grey"
          :href="'mailto:'+driver.contactEmail"
          v-if="!!driver.contactEmail"
        >
          <v-icon>mail</v-icon>
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn flat icon color="red lighten-3" @click="deleteDialog = true" v-if="userAuthClass">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-card-actions>
      <slot name="parentActions"></slot>
      <div class="card-divider grey lighten-2" style="margin-top: 0px;"></div>

      <div class="card-footer text-xs-left">
        <time-ago class="grey--text" :subject="driver" :time="driver.updatedAt" needsParse updated>
          <v-icon small color="grey" slot="icon" class="mr-2">access_time</v-icon>
        </time-ago>

      </div>
      <div style="width: 100%; height: 2px;" :class="color"></div>
    </v-card>

    <!--EDIT DRIVER DIALOG -->
    <v-dialog
      v-model="edit"
      max-width="700px"
      lazy
      @keydown.esc="edit = false"
      v-if="userAuthClass || allowInductionEntry"
    >
      <edit-driver :driver="driver" @close="edit = false" @driverEdited="displaySnack"></edit-driver>
    </v-dialog>

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog
      lazy
      v-model="deleteDialog"
      max-width="400px"
      @keydown.esc="deleteDialog = false"
      v-if="userAuthClass"
    >
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{driver.name}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteDriver(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import DriverService from "@/services/requests/driverService";
import getColorFromChar from "@/services/helpers/getColorFromChar";
import EditDriver from "@/components/drivers/editDriver";
import DisplaySnack from "@/services/mixins/displaySnack";
import MasterFileComplianceResources from "@/modules/complianceResources/masterFileComplianceResources";
export default {
  components: {
    EditDriver,
    MasterFileComplianceResources
  },
  mixins: [DisplaySnack],
  data() {
    return {
      edit: false,
      deleteDialog: false,
      chooseChildPage: false
    };
  },
  methods: {
    deleteDriver() {
      var driver = this.driver;
      DriverService.deleteDriver(driver.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit("drivers/deleteFromArrayStateByValue", {
            prop: "drivers",
            value: driver
          });
          this.snack({ text: "Driver was deleted!", color: "yellow" });
        })
        .catch(err => {
          //console.log("An error occured");
          this.snackError();
        });
    },
    goToCompliance() {
      this.model = "driver";
      this.subjectId = this.driver.id;
      this.contractorId = null;
      this.vehicleId = null;
      this.driverId = this.driver.id;
      this.$router.push({
        name: "compliance"
      });
    }
  },
  props: {
    driver: Object,
    index: Number
  },
  computed: {
    color() {
      return getColorFromChar(this.driver.name.charCodeAt(0));
      //return this.$store.state.global.pages.driver.color;
    },
    letter() {
      return this.driver.name.charAt(0);
    },
    model: Store.getSet({ store: "compliance", prop: "model" }),
    subjectId: Store.getSet({ store: "compliance", prop: "subjectId" }),
    contractorId: Store.getSet({ store: "compliance", prop: "contractorId" }),
    vehicleId: Store.getSet({ store: "compliance", prop: "vehicleId" }),
    driverId: Store.getSet({ store: "compliance", prop: "driverId" })
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.overlap-avatar {
  margin-top: -35px;
  border: 6px solid #eee;
  border-color: #eee !important;
}
</style>
